function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #626a84;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.5px;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Pick_Date",
  "data-name": "Pick Date",
  transform: "translate(-739.25 -138.25)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1703",
  "data-name": "Rectangle 1703",
  className: "cls-1",
  width: 25,
  height: 24,
  rx: 2,
  transform: "translate(740 141)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_516",
  "data-name": "Line 516",
  className: "cls-1",
  y2: 4,
  transform: "translate(759 139)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_517",
  "data-name": "Line 517",
  className: "cls-1",
  y2: 4,
  transform: "translate(746 139)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_518",
  "data-name": "Line 518",
  className: "cls-1",
  x2: 24,
  transform: "translate(740 147)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1704",
  "data-name": "Rectangle 1704",
  className: "cls-1",
  width: 3,
  height: 3,
  transform: "translate(744 151)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1705",
  "data-name": "Rectangle 1705",
  className: "cls-1",
  width: 3,
  height: 3,
  transform: "translate(758 151)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1706",
  "data-name": "Rectangle 1706",
  className: "cls-1",
  width: 3,
  height: 3,
  transform: "translate(751 151)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1707",
  "data-name": "Rectangle 1707",
  className: "cls-1",
  width: 3,
  height: 3,
  transform: "translate(744 158)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1708",
  "data-name": "Rectangle 1708",
  className: "cls-1",
  width: 3,
  height: 3,
  transform: "translate(758 158)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1709",
  "data-name": "Rectangle 1709",
  className: "cls-1",
  width: 3,
  height: 3,
  transform: "translate(751 158)"
}));

var SvgDatePicker = function SvgDatePicker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26.5 27.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDatePicker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/date-picker.23d84b40.svg";
export { ForwardRef as ReactComponent };